import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalStateProvider } from './components/GlobalStateContext'
import { PSContextProvider } from './PLANO SAFRA/opoio/PSContext'
import { AnalisesContextProvider } from './ANALISES/AnalisesContext'; 
import { ACProvider } from './ANALISES/Analise Cenarios/AnaliseCenariosContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStateProvider>
      <PSContextProvider>
        <AnalisesContextProvider>
          <ACProvider>
             <App />
          </ACProvider>
        </AnalisesContextProvider>
    </PSContextProvider>
    </GlobalStateProvider>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
